import { branch, compose, renderNothing, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import PaymentGroup from "./PaymentGroup";
var enhancer = compose(branch(function (_ref) {
  var payments = _ref.payments;
  return !payments || payments.length <= 0;
}, renderNothing), setPropTypes({
  payments: PropTypes.array,
  section: PropTypes.string,
  title: PropTypes.string
}));
export default enhancer(PaymentGroup);